import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAlertSupplierUnconfirmedConsolidatedSlice = createApi(`GetAlertSupplierUnconfirmedConsolidatedSlice`,"GET");

const GetAlertSupplierUnconfirmedConsolidatedSlice = createSlice({
  name: 'GetAlertSupplierUnconfirmedConsolidatedSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAlertSupplierUnconfirmedConsolidatedSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAlertSupplierUnconfirmedConsolidatedSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAlertSupplierUnconfirmedConsolidatedSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAlertSupplierUnconfirmedConsolidatedSlice.reducer;